module.exports = __webpack_public_path__ + "/img/ToDpak-Custom-Footprint-BC6TZg.svg";